import { Component, EventEmitter, Output } from '@angular/core';
import { CryptoService } from 'src/app/core/helpers/crypto.service';
import { DpfService } from 'src/app/core/services/dpf.service';
import { GoogleAuthService } from 'src/app/core/services/google-auth.service';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { LocaleService } from 'src/app/core/services/locale.service';
import { RouterPath } from 'src/app/shared/models';
import { DocsService } from 'src/app/views/docs/docs.service';

@Component({
    selector: 'app-login-modal',
    templateUrl: './login-modal.component.html',
    styleUrls: ['./login-modal.component.scss'],
})
export class LoginModalComponent {
    @Output() closed = new EventEmitter<void>();
    @Output() openSignUp = new EventEmitter<void>();
    @Output() switchToSetProfile = new EventEmitter<void>();
    @Output() openForgotPassword = new EventEmitter<void>();

    username = '';
    password = '';
    remember = false;
    showPassword = false;
    loginStatus = false;
    isLoading = false;

    protected readonly RouterPath = RouterPath;

    get lang(): string {
        return this.localeService.getCurrentLocale();
    }

    constructor(
        private googleAuth: GoogleAuthService,
        private dpfService: DpfService,
        private cryptoService: CryptoService,
        private appStateService: AppStateService,
        private localeService: LocaleService,
        private docsService: DocsService
    ) {}

    togglePassword() {
        this.showPassword = !this.showPassword;
    }

    close() {
        this.closed.emit();
    }

    onSubmit() {
        // console.log('Login:', this.username, this.password);
        // Add login logic here
    }

    signUp() {
        this.closed.emit();
        this.openSignUp.emit();
    }

    async login() {
        this.isLoading = true;
        const body = {
            userName: this.username,
            password: this.cryptoService.encrypt(this.password),
        };
        const res = await this.dpfService.login(body);
        if (!res?.status) {
            this.loginStatus = true;
            this.isLoading = false;
            return;
        }
        this.loginStatus = false;
        // Clear Google One Tap prompt if it was shown (user chose login modal instead)
        this.googleAuth.cancelOneTap();
        this.closed.emit();
        localStorage.setItem('token', res.data.token);
        await this.dpfService.authCheck(); // Call this after token is retrieved
        this.appStateService.nextTokenValue(true); // Call this after jwt is retrieved from authCheck()
        await this.docsService.acceptActivePoliciesIfNeeded(localStorage.getItem('userId'));
        this.localeService.navigate(RouterPath.HOME);
        this.isLoading = false;
    }

    loginWithGoogle() {
        this.googleAuth.init(async (idToken) => {
            const body = { idToken };
            const res = await this.dpfService.loginWithGoogle(body);
            if (!res?.status) {
                return;
            }
            localStorage.setItem('token', res.data);
            await this.dpfService.authCheck(); // Call this after token is retrieved
            this.appStateService.nextTokenValue(true); // Call this after jwt is retrieved from authCheck()
            await this.docsService.acceptActivePoliciesIfNeeded(localStorage.getItem('userId'));
            const resp = await this.dpfService.checkProfile();
            if (resp?.status && resp?.data) {
                this.switchToSetProfile.emit();
            } else {
                this.localeService.navigate(RouterPath.HOME);
            }
            this.closed.emit();
        });

        this.googleAuth.renderButton('googleBtn');
        this.googleAuth.promptOneTap();
    }

    forgotPassword() {
        this.closed.emit();
        this.openForgotPassword.emit();
    }
}
